export const Widgets = {
  Standard: 'standard',
  Voting: 'voting',
  Total: 'total',
  DonationAlert: 'donation-alert',
  LastDonation: 'last-donation',
  TopDonation: 'top-donation',
  TopDonor: 'top-donor',
  Progress: 'progress',
  LastComment: 'last-comment',
  ProjectLogos: 'project-logos',
  Milestones: 'milestones',
} as const

export type Widgets = (typeof Widgets)[keyof typeof Widgets]
